import { sites } from './sites'

export const monitoring = {
  sites,
}
